import { useConfig , useOidcWithAdmin } from '@revenuewell/front-end-bundle';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNotifications } from '@revenuewell/uc-notifications-client';
import { usePubnub } from '../../../hooks/use-pubnub/use-pubnub';
import { ReactComponent as MessengerButtonSvg } from '../../../assets/menu/icon-messenger.svg';
import SidebarItem from '../../shared/sidebar/sidebar-item';
import PublisherService from '../../../services/publisher-service/publisher-service';
import { useLocations } from 'apps/wrapper/src/hooks/use-locations';

export type MessengerButtonProps = {
    to: string;
    isActive?: boolean;
    onClick?: () => void;
};

const MessengerButton = ({ to, isActive, onClick }: MessengerButtonProps) => {
    const { mailboxes } = usePubnub();
    const config = useConfig();
    const { oidcService } = useOidcWithAdmin();
    const [hasUnread, setUnread] = useState(false);
    const { listen } = useNotifications();
    const { selectedLocation } = useLocations();
    const mailboxesFromLocation = useMemo(() => mailboxes.filter(d => d.locationId === selectedLocation?.id), [mailboxes, selectedLocation]);
    const textPublisher = useMemo(() => new PublisherService(config.config, oidcService, 0), [config, oidcService]);

    const fetchUnread = useCallback(async () => {
      if (!mailboxesFromLocation.length) return;

      const { total } = await textPublisher.channelsUnreadCounts({
        mailboxIds: mailboxesFromLocation.map((d) => d.id)
      });

      setUnread(total > 0);
    }, [setUnread, textPublisher, mailboxesFromLocation]);

    useEffect(() => {
        fetchUnread();

        return listen('channel-update', () => {
            fetchUnread();
        });
    }, [listen, fetchUnread]);

    return (
        <SidebarItem title='Messenger' onClick={onClick} to={to} isActive={isActive} hasNotification={hasUnread}>
            <MessengerButtonSvg />
        </SidebarItem>
    );
}

export default MessengerButton;
